// extracted by mini-css-extract-plugin
export default {"channelNote":"BxBXt43HPJiaXkLr","showTranscript":"YZ4PfFPocBqMjUfS"};